var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNegativeSentiment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,23.25A11.25,11.25,0,1,0,.75,12,11.263,11.263,0,0,0,12,23.25Z",
    fill: "#fd5d5d",
    opacity: 0.173
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6,9.75A.75.75,0,0,1,6.75,9h1.5A.75.75,0,0,1,9,9.75v6.5a.75.75,0,0,1-.75.75H6.75A.75.75,0,0,1,6,16.25Z",
    transform: "translate(9 -2)",
    fill: "#fd5d5d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.032,10.63l.7-4.48A2.005,2.005,0,0,1,11.7,4.5h1.03c4.24,0,6.04,1.41,6.04,1.41l.25.2v6.17l-.25.13s-2.65,1.42-2.65,3.39c0,1.42-.28,1.7-.85,1.7a2.122,2.122,0,0,1-1.91-2.26,7.2,7.2,0,0,1,.31-2.26H11a2,2,0,0,1-1.97-2.35Z",
    transform: "translate(-4.022 2)",
    fill: "#fd5d5d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12,0A12,12,0,1,1,0,12,12.013,12.013,0,0,1,12,0Zm0,22.5A10.5,10.5,0,1,0,1.5,12,10.512,10.512,0,0,0,12,22.5Z",
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75,8h1.5A1.752,1.752,0,0,1,10,9.75v6.5A1.752,1.752,0,0,1,8.25,18H6.75A1.752,1.752,0,0,1,5,16.25V9.75A1.752,1.752,0,0,1,6.75,8Zm1.5,8.5a.25.25,0,0,0,.25-.25V9.75a.25.25,0,0,0-.25-.25H6.75a.25.25,0,0,0-.25.25v6.5a.25.25,0,0,0,.25.25Z",
    transform: "translate(9 -2)",
    fill: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.953,4h1.03c4.448,0,6.421,1.506,6.5,1.57l.256.2A.75.75,0,1,1,18.8,6.946l-.25-.2c-.005,0-1.7-1.246-5.572-1.246h-1.03a1.251,1.251,0,0,0-1.232,1.032l-.7,3.978a1.25,1.25,0,0,0,1.232,1.47h3.42a.75.75,0,0,1,.626,1.163,3.765,3.765,0,0,0-.437,1.848c0,1.141.445,1.51.66,1.51h.012a3.284,3.284,0,0,0,.089-.952c0-2.391,2.921-3.984,3.046-4.051l.257-.134a.75.75,0,0,1,.694,1.33l-.25.13c-.619.335-2.247,1.486-2.247,2.725,0,.8,0,2.45-1.6,2.45-1.041,0-2.16-.942-2.16-3.01a5.764,5.764,0,0,1,.2-1.51H11.253a2.75,2.75,0,0,1-2.709-3.233l.7-3.977A2.751,2.751,0,0,1,11.953,4Z",
    transform: "translate(-4.523 2)",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegativeSentiment);
export default __webpack_public_path__ + "static/media/negative-sentiment.bb9e5e17ab5da303eb062718b0f74de5.svg";
export { ForwardRef as ReactComponent };